import { useTranslation } from "react-i18next"

import { Button } from "@/components/ui/button"
import { usePagination, useRegisteredFacetIds } from "@/lib/redux-search"
import { useSearchSelector } from "@/lib/redux-search/search-redux-context"
import useSearchContext from "@/lib/redux-search/use-search-context"

/** Clears selected sidebar facets while preserving independently registered filters. */
export function ClearSearchFacets() {
  const { t } = useTranslation("search")
  const { filters, search } = useSearchContext()
  const pagination = usePagination()
  const facetIds = useRegisteredFacetIds()
  const activeFilters = useSearchSelector(filters.activeSelector)
  const selectedFacetIds = facetIds.filter(
    (id) => (activeFilters[id]?.values.length ?? 0) > 0,
  )

  if (selectedFacetIds.length === 0) return null

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={() => {
        selectedFacetIds.forEach((id) => filters.setValues(id, []))
        pagination.setPage(1)
        search()
      }}
    >
      {t("result.clear_filters")}
    </Button>
  )
}
